import { render, staticRenderFns } from "./PlateTextMoreItem.vue?vue&type=template&id=313c1944&scoped=true"
import script from "./PlateTextMoreItem.vue?vue&type=script&lang=js"
export * from "./PlateTextMoreItem.vue?vue&type=script&lang=js"
import style0 from "./PlateTextMoreItem.vue?vue&type=style&index=0&id=313c1944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c1944",
  null
  
)

export default component.exports